import { useAsyncAtom } from '@service-initiation/shared-utils-jotai';

import { repairPriceAsyncAtom } from '../atoms';

export const useRepairPriceAsyncAtom = () => useAsyncAtom(repairPriceAsyncAtom);
